import { api } from '../index';

const prefix = '/api/basic_info/code/';

//코드 관련
export function apiSelectCodeList(param) {
	return api.post(prefix + 'selectCodeList', param);
}

export function apiCheckCodeExists(param) {
	return api.post(prefix + 'checkCodeExists', param);
}

export function apiInsertCode(param) {
	param.mode = 'insert';
	return apiSubmitCode(param);
}

export function apiInsertCodeSimple(param) {
	param.mode = 'insertSimple';
	return apiSubmitCode(param);
}

export function apiUpdateCode(param) {
	param.mode = 'update';
	return apiSubmitCode(param);
}

export function apiUpdateOrder(param) {
	return api.post(prefix + 'updateOrder', param);
}

export function apiUpdateOrderList(param) {
	return api.post(prefix + 'updateOrderList', param);
}

export function apiDeleteCode(param) {
	param.mode = 'delete';
	return apiSubmitCode(param);
}

function apiSubmitCode(param) {
	return api.post(prefix + 'submitCode', param);
}

export function apiInsertPicture(param) {
	return api.post(prefix + 'insertPicture', param);
}

export function apiDeletePicture(param) {
	return api.post(prefix + 'deletePicture', param);
}

//Zone 관련
export function apiSelectZoneList(param) {
	return api.post(prefix + 'selectZoneList', param);
}

export function apiSelectZoneChargeList(param) {
	return api.post(prefix + 'selectZoneChargeList', param);
}

export function apiCheckZoneChargeExists(param) {
	return api.post(prefix + 'checkZoneChargeExists', param);
}

export function apiInsertZoneCharge(param) {
	param.mode = 'insert';
	return apiSubmitZoneCharge(param);
}

export function apiUpdateZoneCharge(param) {
	param.mode = 'update';
	return apiSubmitZoneCharge(param);
}

export function apiDeleteZoneCharge(param) {
	param.mode = 'delete';
	return apiSubmitZoneCharge(param);
}

function apiSubmitZoneCharge(param) {
	return api.post(prefix + 'submitZoneCharge', param);
}

//Zipcode 관련

export function apiSelectZipcodeList(param) {
	return api.post(prefix + 'selectZipcodeList', param);
}

export function apiSelectStateList(param) {
	return api.post(prefix + 'selectStateList', param);
}

export function apiInsertZipcode(param) {
	param.mode = 'insert';
	return apiSubmitZipcode(param);
}

export function apiUpdateZipcode(param) {
	param.mode = 'update';
	return apiSubmitZipcode(param);
}

export function apiDeleteZipcode(param) {
	param.mode = 'delete';
	return apiSubmitZipcode(param);
}

function apiSubmitZipcode(param) {
	return api.post(prefix + 'submitZipcode', param);
}

//Shipment 관련

export function apiSelectShipmentList(param) {
	return api.post(prefix + 'selectShipmentList', param);
}

export function apiCheckShipmentExists(param) {
	return api.post(prefix + 'checkShipmentExists', param);
}

export function apiInsertShipment(param) {
	param.mode = 'insert';
	return apiSubmitShipment(param);
}

export function apiUpdateShipment(param) {
	param.mode = 'update';
	return apiSubmitShipment(param);
}

export function apiDeleteShipment(param) {
	param.mode = 'delete';
	return apiSubmitShipment(param);
}

function apiSubmitShipment(param) {
	return api.post(prefix + 'submitShipment', param);
}

// git_test
// git_test2
// git_test3
